import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path, find, propEq, union, identity } from "ramda";

export const ADD_NOTE = "USER@NOTE::ADD";
export const ADD_NOTE_MULTIPLE = "USER@NOTE::ADD_MULTIPLE";
export const UPDATE_NOTE = "USER@NOTE::UPDATE";
export const REMOVE_NOTE = "USER@NOTE::REMOVE";

export const addNote = createAction(ADD_NOTE);
export const addAllNotes = createAction(ADD_NOTE_MULTIPLE);
export const updateNote = createAction(UPDATE_NOTE);
export const removeNote = createAction(REMOVE_NOTE);

const getNotes = path(["user", "notes"]);

export const selectNotes = createSelector(getNotes, identity);

export const selectNoteById = id =>
  createSelector(getNotes, find(propEq("_id", id)));

const initialState = () => [];

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case ADD_NOTE:
      return [...state, action.payload];
    case ADD_NOTE_MULTIPLE:
      return union(state, action.payload);
    case UPDATE_NOTE:
      return state.map(note => {
        if (action.payload._id === note._id) {
          return {
            ...note,
            _rev: action.payload._rev || note._rev,
            text: action.payload.text
          };
        }
        return note;
      });
    case REMOVE_NOTE:
      return state.filter(note => note.materialId !== action.payload);
    default:
      return state;
  }
}
